define.alias("ember-cli-clipboard/helpers/is-clipboard-supported", "preview-grid/helpers/is-clipboard-supported");